export default __webpack_public_path__ + "static/media/Rakesh.d69450ca.png";